module.exports = __webpack_public_path__ + "img/lg_ring_r_e_null_0@3x.b85a6a1a.png";